// Shared Recharts axis styling so tick labels and axis lines stay readable on
// both light and dark dashboard backgrounds.
//
// Why fixed colors instead of `currentColor` + Tailwind classes: Recharts
// renders axis tick text inside its own SVG <text> nodes that do not reliably
// inherit the `currentColor` set via the parent axis `className`. That left
// ticks rendering black (the SVG default) and unreadable in dark mode. The
// mid-tone grays below read on both white (light mode) and gray-900 (dark mode)
// backgrounds, so no theme switching is required.

// Tick text color — #9CA3AF (Tailwind gray-400). Mid-tone, readable on light
// and dark backgrounds alike.
export const CHART_AXIS_TICK_FILL = "#9CA3AF";

// Tick font size — matches the existing chart text size used across CI panels.
export const CHART_AXIS_TICK_FONT_SIZE = 12;

// Axis line + tick mark color — #374151 (Tailwind gray-700). Clearly visible
// on light backgrounds and subtly present (not jarring) on dark backgrounds.
export const CHART_AXIS_STROKE = "#374151";

// Spread onto any <XAxis>/<YAxis> to apply tick + line styling, e.g.
//   <XAxis dataKey="name" {...axisProps} />
//   <YAxis {...axisProps}><Label style={axisLabelStyle} ... /></YAxis>
export const axisProps = {
  tick: { fill: CHART_AXIS_TICK_FILL, fontSize: CHART_AXIS_TICK_FONT_SIZE },
  stroke: CHART_AXIS_STROKE,
  tickLine: { stroke: CHART_AXIS_STROKE },
  axisLine: { stroke: CHART_AXIS_STROKE },
};

// Style object for recharts <Label> axis titles, e.g.
//   <Label value="Rate (USD)" angle={-90} position="insideLeft" style={axisLabelStyle} />
export const axisLabelStyle = {
  textAnchor: "middle",
  fill: CHART_AXIS_TICK_FILL,
  fontSize: CHART_AXIS_TICK_FONT_SIZE,
};
